import { useEffect } from 'react';
import { DynamicsV2 } from '@/services/dynamics/dynamics-v2';
import { EDynV2SessionEvent } from '@/services/dynamics/enums/v2/session-event.enum';
import { logger } from '@/services/logger.service';

export const useDynEvents = () => {
  useEffect(() => {
    const sub$ = DynamicsV2.events$.subscribe((item) => {
      logger.log(`[DYNAMICS] incoming event: `, item);
      switch (item.event) {
        case EDynV2SessionEvent.SWITCHED: {
          const session = item.session;

          if (session.focused && session.navigateTo) {
            session.navigateTo();
          }
          break;
        }

        case EDynV2SessionEvent.EMPTY: {
          break;
        }
      }
    });

    return () => sub$.unsubscribe();
  }, []);
};
